import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';


const Link = ({
                label,
                link,
                target = '_blank',
                customContainerStyles,
                customLinkStyles,
              }) => (
  <div className={classnames(styles.container, customContainerStyles)}>
    <a
      href={link}
      target={target}
      className={classnames(styles.label, customLinkStyles)}
    >
      {label}
    </a>
  </div>
);

Link.propTypes = {
  label: PropTypes.node,
  link: PropTypes.string,
  target: PropTypes.string,
  customContainerStyles: PropTypes.object,
  customLinkStyles: PropTypes.object,
};

export default Link;
